import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

const INTERVIEW_API = process.env.REACT_APP_API_INTERVIEW;

const initialState = {
  // talentId -> { data, loading, error, loaded, fetchedAt }
  byTalentId: {}
};

const slice = createSlice({
  name: 'introInterview',
  initialState,
  reducers: {
    introFetchStart(state, action) {
      const { talentId } = action.payload;
      state.byTalentId[talentId] = {
        ...(state.byTalentId[talentId] || {}),
        loading: true,
        error: null
      };
    },
    introFetchSuccess(state, action) {
      const { talentId, data } = action.payload;
      state.byTalentId[talentId] = {
        data,
        loading: false,
        error: null,
        loaded: true,
        fetchedAt: Date.now()
      };
    },
    introFetchError(state, action) {
      const { talentId, error } = action.payload;
      state.byTalentId[talentId] = {
        ...(state.byTalentId[talentId] || {}),
        loading: false,
        error,
        loaded: true
      };
    },
    invalidateIntro(state, action) {
      delete state.byTalentId[action.payload];
    }
  }
});

export const { introFetchStart, introFetchSuccess, introFetchError, invalidateIntro } = slice.actions;

export function getIntroInterview(talentId, { force = false } = {}) {
  return async (dispatch, getState) => {
    if (!talentId) return;

    const existing = getState().introInterview.byTalentId[talentId];
    if (!force && existing && existing.loaded) return;

    dispatch(introFetchStart({ talentId }));
    try {
      const { data } = await axios.get(
        `${INTERVIEW_API}/api/audio-interview/${talentId}/total-interview-data`,
        { params: { purpose: 'talent_intro' } }
      );
      dispatch(introFetchSuccess({ talentId, data: data?.introInterview ?? null }));
    } catch (error) {
      console.error('Error fetching intro interview:', error);
      dispatch(introFetchError({ talentId, error: error?.message || 'Failed to fetch intro interview' }));
    }
  };
}

export default slice.reducer;
